import Vue from 'vue'
import store from '../store/index'

// add translations directly to the application
Vue.i18n.add('pt-BR', require('./pt-BR.json'))
Vue.i18n.add('en', require('./en.json'))
Vue.i18n.add('es', require('./es.json'))
Vue.i18n.add('cn', require('./cn.json'))

var locale = 'en'

if (localStorage.getItem("currentUser") !== null) {
  locale = store.state.currentUser.locale
}

// set the start locale to use
Vue.i18n.set(locale)

// set fallback for non-translated strings
Vue.i18n.fallback('en')
